import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";
import { userCreateAction } from "./../../../modules/users/action";
import UsersForm from "./UsersForm";

class CreateUser extends Component {
  state = {
    successMessage: false
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.userCreated && nextProps.userCreated.status === 200) {
      this.setState({ successMessage: true });
    }
  }

  handleSubmit = userInfo => {
    this.props.userCreateAction(userInfo);
  };

  render() {
    const { successMessage } = this.state;
    if (successMessage) {
      return <Redirect to="/settings/users" />;
    }
    return (
      <UsersForm
        buttonLabel="Create User"
        formLabel="Create User"
        SubFarmId={this.props.SubFarmId}
        handleSubmit={this.handleSubmit}
        MainFarmId={this.props.MainFarmId}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    userCreated: state.settingsUserReducer.userCreated,
    SubFarmId: state.FarmManagementReducer.SubFarmId,
    MainFarmId: state.FarmManagementReducer.MainFarmId
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ userCreateAction }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateUser);



// WEBPACK FOOTER //
// ./src/components/private/Users/CreateUser.js